import { render, staticRenderFns } from "./TrainingsInfoModal.vue?vue&type=template&id=0d654c44&scoped=true"
import script from "./TrainingsInfoModal.vue?vue&type=script&lang=js"
export * from "./TrainingsInfoModal.vue?vue&type=script&lang=js"
import style0 from "./TrainingsInfoModal.vue?vue&type=style&index=0&id=0d654c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d654c44",
  null
  
)

export default component.exports